<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
    .mb-5
    section
      //- .tab-wrap
        .tab-item(v-for="tab in tabs", @click="tabScroll(tab.offsetTop)") {{ tab.name }}
    .mb-10
    section
      .section-title 我要報名
      router-link.btn.ghost-btn(:to="{name: 'user'}") 報名進度確認
      .mb-6
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 報名資格
        .content
          ul
            li 1. 需為 4Gamers 會員 （需成為 4Gamers 會員並通過 Email 認證）
            li
              .mb-3
              a.btn.ghost-btn(href="https://www.4gamers.com.tw/member/player", target="_blank") 檢視 Email 狀態
              .mb-3
            li 2. 於 2017 年 11 月 23 日 已年滿 18 歲
          .steps-wrap
            .step
              .number 1
              .content 呼朋引伴成為 4Gamers 會員
            .step.multiple(style="margin-bottom:21px;")
              .number 2
              .content
                | 推舉團長進行
                br
                | 團體早鳥票報名
                br
                small (請記得提供團長： 1. 4Gamers 帳號　2. 身份證後四碼)
            .step.multiple
              .number 3
              .content
                | 審核通過收到
                br
                | FamiPort繳費代碼
            .step.multiple
              .number 4
              .content
                | 繳費完成
                br
                | 可自行劃位
            .step
              .number 5
              .content 完成報名
    .mb-10
    section
      .section-title 報名須知
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 《BYOC進／撤場時間》
        .content
          ul
            li 進場時間：11 月 23 日（四）12:00 － 20:00 及 11 月 24 日（五）12:00 － 20:00
            li 撤場時間：11 月 26 日（日）16:00 － 18:00，主辦單位會在 17:30 開始撤場
            br
            li 進場報到時請出示個人身份證明文件與劃位票卷（Email或登入官網皆可）
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 《BYOC 區進出規範》
        .content
          ul
            li 1. BYOC 區僅限事先報名並完成報到手續的玩家及相關工作人員可進入。
            li 2. BYOC 玩家於本活動期間可憑感應式識別手環全天候 24 小時進出 BYOC 區。
            li 3. 需進出 BYOC 區域的相關工作人員需出示可通行 BYOC 的通行證才可入場。
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 《 BYOC 注意事項》
        .content
          ul
            li 1. 所有參加者須年滿 18 歲，入場時將以報名時所登錄的資訊為準，查驗參加者之身分證明文件，以確保每位參加者均合乎基本年齡限制。若遇資料不符者將無法入場，且不提供退費服務。
            li 2. BYOC 區玩家進場時需攜帶電腦配備，包含電腦主機、筆電、家用電視遊戲主機等任一設備，不包含手機、平板電腦或掌上型遊戲主機，若違反此規則主辦單位有權取消資格且不提供退費服務。
            li 3. 本活動所有銷售出之票券僅供個人娛樂之使用，活動現場歡迎任何創意佈置。範圍僅限個人桌面之寬度與深度，高度從地面算起不得超過 180 公分。
            li 4. BYOC 參加者禁止於 BYOC 區及座位上進行非經官方許可的商業行為，如：商品展示、宣傳與販售（包含但不限於展示廠商的產品看板、DM、規格表等商業廣告資訊）。
            li 5. 為保障參加者及參展廠商權益，並維護 BYOC 區進出管理規範，參加者設備不得由廠商提供並進場設置，還請自行攜帶相關設備進場。
            li 6. 以上規範除已向主辦單位申請並取得同意之參加者外，若有違反者大會人員會依狀況要求即刻改善或取消參加資格。
            li 7. 主辦單位保留活動之最後修改、解釋與中止權力。
            li 8. 主辦單位僅負責進出場人員之控管，BYOC 參加者請務必留意自身所攜帶之設備及個人財物。

      .paragraph-wrap
        .em-title
          .icon-logo
          .text 《 主辦單位 4Gamers 將提供每席 BYOC  項目 》
        .content
          ul
            li 1. 個人專屬感應式識別手環 x 1
            li 2. 獨立個人空間（桌面寬度 90 公分、深度 60 公分、高度 75 公分）、椅子 x 1
            li 3. 網路插座 x 1（須自備網路線）
            li 4. 110 v 插座 x 1（須自備延長線材）
            li 5. 生存包 x 1
    section
      .section-title 報名階段與費用
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 團體票：9 月 4 日起 － 10 月 31 日止
      .content
        .tickets-info-wrap
          .ticket
            .title 團體票
            .mb-5
            img(src="~assets/tickets-img/img-group-hover.png")
            .mb-3
            .price NT$2,500/席
            .description 一次可報名 5~10 席
            router-link.btn.ghost-btn(:to="{name: 'tickets'}") 前往購票
          .ticket
            .title 團體潛水票
            .mb-5
            img(src="~assets/tickets-img/img-group-dive-hover.png")
            .mb-3
            .price NT$2,800/席
            .description 一次可報名 5~10 席
            .btn.ghost-btn(@click="explantion('潛水區')") 潛水區 說明
          //- .ticket
            .title 團體票 官方限定 VIP
            img(src="~assets/tickets-img/img-group-early-hover.png")
            .price NT$2,300/席
            .description 一次可報名 5~10席
            .btn.ghost-btn(@click="explantion('VIP')") VIP 說明
        .mb-4
        router-link.btn.ghost-btn(:to="{name: 'tickets'}") 前往購票頁面
        .mb-4
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 個人票：11 月 1 日起 － 11 月 10 日止
      .content
        .tickets-info-wrap
          .ticket
            .title 個人票
            img(src="~assets/tickets-img/img-single-hover.png")
            .price NT$2,500/席
            .description 一次可報名 1 席
            router-link.btn.ghost-btn(:to="{name: 'tickets'}") 前往購票
          .ticket
            .title 個人潛水票
            img(src="~assets/tickets-img/img-single-dive-hover.png")
            .price NT$2,800/席
            .description 一次可報名 1 席
            .btn.ghost-btn(@click="explantion('潛水區')") 潛水區 說明
        .mb-4
        router-link.btn.ghost-btn(:to="{name: 'tickets'}") 前往購票頁面
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 身障票：9 月 4 日起 － 11 月 10 日止
      .content
        .tickets-info-wrap
          .ticket
            .title 身障票
            img(src="~assets/tickets-img/img-bodily-hover.png")
            .price NT$1,000/2席
            .description 一次可報名 1~2 席
            .btn.ghost-btn(@click="explantion('身障票')") 身障票 說明
        .mb-4
        router-link.btn.ghost-btn(:to="{name: 'tickets'}") 前往購票頁面
    .paragraph-wrap
      .em-title
        .icon-logo
        .text 潛水區說明：該區域限定在 “D區” 。 WirForce 活動期間不會有廠商活動在該區進行。
      .em-title
        .icon-logo
        .text 身障票說明：＊一次可報名 2 席，需傳真身障證明方可報名，2 席座位將為隔壁，由大會安排在指定身障席。
    .mb-60
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'about',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
    explantion (ticketType) {
      switch (ticketType) {
        case '潛水區':
          this.$swal({
            title: '潛水區說明',
            html: '<div>＊潛水區說明：該區域限定位子在 D區。<br> WirForce 活動期間不會有廠商活動在該區進行。</div>',
            confirmButtonText: '返回'
          })
          break
        case 'VIP':
          this.$swal({
            title: 'VIP 說明',
            html: '<div>＊需經過官方通知與審核方可通過此區方案。</div>',
            confirmButtonText: '返回'
          })
          break
        case '身障票':
          this.$swal({
            title: '身障票 說明',
            html: '<div>欲購買身障票玩家 <br /> 請以『 <span style="color: #ff2a48; text-decoration: none; font-weight: bold;"> WirForce 2017 身障票購票申請 </span> 』 <br />作為信件標題，寄至 WirForce 票務信箱：<br />『 <a href="mailto:WirForce@4gamers.com.tw" style="color: #ff2a48; text-decoration: none; font-weight: bold;"> WirForce@4gamers.com.tw </a> 』 <br />會有專人為您處理</div>',
            confirmButtonText: '返回'
          })
          break
      }
    }
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
$red-bg: #381924
.steps-wrap
  .step
    position: relative
    margin:
      bottom: 60px
      left: 30px
    &.multiple
      margin-bottom: 40px
    .number
      border: 1px solid $red
      background-color: $red-bg
      +border-radius(999px)
      width: 30px
      height: 30px
      text-align: center
      position: absolute
      left: -30px
      line-height: 26px
      color: $red
      font-weight: bold
      font-size: 18px
    &:not(:last-child)
      &:after
        content: ''
        border:
          left: 1px solid $red
          right: 1px solid $red
        background-color: $red-bg
        padding: 0 1px
        position: absolute
        top: 100%
        height: 58px
        z-index: 1
        left: -16px
        top: 29px
    .content
      color: #fff
      margin-left: 15px
      padding-top: 5px

.tickets-info-wrap
  margin-top: 32px
  .ticket
    margin: 0 16px 16px 0
    padding: 24px
    display: inline-block
    text-align: center
    border: 1px solid #888
    &:hover
      border: 1px solid $red
      box-shadow: inset 0 0 10px 1px $red
    .title
      color: #fff
      font-size: 20px
      font-weight: bold
      margin-bottom: 16px
    img
      margin-bottom: 16px
    .price
      color: #fff
      font-size: 20px
      font-weight: bold
      margin-bottom: 16px
    .description
      margin-bottom: 24px
    a
</style>



// WEBPACK FOOTER //
// about.vue?6b12d23a